import { LoadingIndicator } from 'lib/graphql';

import { CenterLayout } from './CenterLayout';

export const LoadingPage = () => {
  return (
    <CenterLayout>
      <div style={{ fontSize: '2em' }}>
        <LoadingIndicator isLoading />
      </div>
    </CenterLayout>
  );
};
